import {State} from '@shared/store/reducers/Index';
import React from 'react';
import {useSelector} from 'react-redux';

const useIsGenerateProcedureEnabled = (): boolean => {
  const {list: clinicsList = []} = useSelector((state: State) => state.clinics);
  const {selectedClinicId} = useSelector((state: State) => state.clinics);
  const clinicId = selectedClinicId?.[0];
  const selectedClinic = clinicsList.find(
    (clinic: any) => clinic.id === clinicId
  );
  const clinicTicketConfig: Record<string, any> = React.useMemo(() => {
    const ticketConfig = {};
    if (Array.isArray(selectedClinic?.ticket_config)) {
      selectedClinic.ticket_config.forEach(
        (i: {config_key: string; config_value: string}) => {
          ticketConfig[i.config_key] = i.config_value;
        }
      );
    }
    return ticketConfig;
  }, [selectedClinic]);
  const isGenerateProcedureEnabled =
    clinicTicketConfig?.cpt_code_generation !== 'false';
  return isGenerateProcedureEnabled;
};

export default useIsGenerateProcedureEnabled;
